import { useState, useEffect } from "react"

// https://gist.github.com/joshuacerbito/ea318a6a7ca4336e9fadb9ae5bbb87f4#gistcomment-3059634

export default () => {
  const [scroll, setScroll] = useState({
    scrollX: typeof window !== "undefined" ? window.scrollX : 0,
    scrollY: typeof window !== "undefined" ? window.scrollY : 0,
    direction: "down",
    velocity: 0,
    lastScrollY: typeof window !== "undefined" ? window.scrollY : 0,
  })

  useEffect(() => {
    let rafId
    let lastScrollY = window.scrollY
    let lastTime = Date.now()

    const THRESHOLD = 50 // Minimum scroll distance
    const MIN_VELOCITY = 0.3 // Minimum velocity to trigger (px/ms)

    const listener = () => {
      rafId = requestAnimationFrame(() => {
        const currentTime = Date.now()
        const currentScroll = window.scrollY
        const timeDiff = currentTime - lastTime
        const scrollDiff = Math.abs(currentScroll - lastScrollY)
        const velocity = scrollDiff / timeDiff

        if (scrollDiff > THRESHOLD || velocity > MIN_VELOCITY) {
          setScroll((prev) => ({
            scrollX: window.scrollX,
            scrollY: currentScroll,
            direction: currentScroll > prev.lastScrollY ? "down" : "up",
            velocity,
            lastScrollY: currentScroll,
          }))
        }

        lastScrollY = currentScroll
        lastTime = currentTime
      })
    }

    window.addEventListener("scroll", listener, { passive: true })
    return () => {
      window.removeEventListener("scroll", listener)
      cancelAnimationFrame(rafId)
    }
  }, [])

  return scroll
}
